import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormGroupName,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AuthService } from '../../_services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorHandlerService } from '../../_services/error-handler.service';

@Component({
  selector: 'app-signup',
  imports: [RouterModule, FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.scss',
})
export class SignupComponent implements OnInit {
  signupForm: any = FormGroupName;
  isLoading: boolean = false;
  errorMessage: string = '';
  private _snackBar = inject(MatSnackBar);
  countries: any = [];
  selectedCountry: any;
  dropdownOpen = false;
  searchQuery = '';
    prefillData: { phone?: string; email?: string; country?:any } | null = null;

  constructor(
    private _fb: FormBuilder,
    private _AS: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private errorHandler: ErrorHandlerService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private el: ElementRef
  ) {}

  ngOnInit() {
    this.formControls();
    this.getCode();
    const state = history.state as {
      phone?: string;
      email?: string;
      route?: string;
      country:any
    };

    if (state?.phone || state?.email) {
      this.prefillData = state;
    }
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    if (returnUrl) {
      this._AS.setRedirectUrl(returnUrl);
    }
  }
  async getCode() {
    await this._AS.getCountryCode().subscribe((res: any) => {
      this.countries = res;
      this.selectedCountry = this.countries.find((c: any) => c.code === 'IN')!;
      console.log('this.selectedCountry',this.selectedCountry)
      this.signupForm.patchValue({
        country: this.selectedCountry ?? { "name": "India", "dial": "+91", "code": "IN", "flag": "🇮🇳" }
      });
      if (this.prefillData?.phone) {
        this.selectedCountry =this.prefillData.country 
        this.signupForm.patchValue({ phone: this.prefillData.phone, country:this.prefillData.country });
      }
      if (this.prefillData?.email) {
        this.signupForm.patchValue({ email: this.prefillData.email });
      }
    });
  }
  formControls() {
    this.signupForm = this._fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required]],
      phone: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(15)]],
      // password: ['', [Validators.required, Validators.minLength(3)]],
      country:['', Validators.required]
    });
  }

  signUser() {
    if (this.signupForm.invalid) {
      this.errorMessage = 'Please fill in all required fields correctly.';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this._AS.userSignUp(this.signupForm.value).subscribe({
      next: (res: any) => {
        this.isLoading = false;

        // Handle SSR mode response
        if (res.message === 'SSR mode') {
          return;
        }

        if (res.status) {
          this._snackBar.open(res.message || 'Login successful!', 'close', {
            duration: 3000,
            panelClass: ['success-snackbar'],
          });
          this.router.navigate(['/otp'], {
            state: { ...res.data, authReturnUrl: this.router.url },
            replaceUrl: true,
          });
        } else {
          this.errorMessage =
            res.message || 'You need account to access this application.';
          this._snackBar.open(this.errorMessage, 'close', {
            duration: 3000,
            panelClass: ['error-snackbar'],
          });
        }
      },
      error: (error) => {
        this.isLoading = false;
        // Handle structured error response
        if (error.status === false) {
          this.errorMessage = error.message;
        } else {
          this.errorMessage =
            'SignUp failed. Please check your credentials and try again.';
        }

        this._snackBar.open(this.errorMessage, 'close', {
          duration: 3000,
          panelClass: ['error-snackbar'],
        });

        // Use error handler for additional logging
        this.errorHandler.handleError(error, 'SignUp');
      },
    });
  }
  showPassword = false;
  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  get filteredCountries() {
    const q = this.searchQuery.toLowerCase();
    return this.countries.filter(
      (c: any) => c.name.toLowerCase().includes(q) || c.dial.includes(q)
    );
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }
  selectCountry(country: any) {
    this.selectedCountry = country;
    this.dropdownOpen = false;
    this.searchQuery = '';
    this.signupForm.patchValue({
      country: country
    });
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(e: Event) {
    if (!this.el.nativeElement.contains(e.target)) this.dropdownOpen = false;
  }
}
